import React from 'react';
import { Flexbox, Typography, Button, Icon } from '@hiiretail/synergy-ui';
import { useIntl } from 'react-intl';
import { AccessControl } from '../../../../../common';
import { Chip } from '../../../../../common/components/Chip/Chip';
import { I18nKeys } from '../../../../../i18n/keys';
import styled from 'styled-components';

const FixedBindingsContainer = styled(Flexbox)`
  padding: ${({ theme }) => theme.spacing(2)}px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background-color: #ffffff;
`;

const StyledButton = styled(Button)`
  padding: 6px 12px;
  color: #000000;

  :disabled {
    background-color: #eeeeee;
  }
`;

type FixedBindingsProps = {
  fixedBindings?: string[];
  isLoading: boolean;
  onAddClick: () => void;
  onRemoveClick: (binding: string) => void;
};

export const FixedBindings: React.FC<FixedBindingsProps> = ({
  fixedBindings = [],
  isLoading,
  onAddClick,
  onRemoveClick,
}) => {
  const intl = useIntl();

  return (
    <FixedBindingsContainer container direction="column" gutter={4} style={{ padding: '2rem' }}>
      <Flexbox container alignItems="center" justifyContent="space-between">
        <Typography variant="header3">
          {intl.formatMessage({ id: I18nKeys.CustomRolesFixedBindings })}
        </Typography>
        <AccessControl permission="iam.custom-role.update" renderIfNoAccess={null}>
          <StyledButton
            onClick={onAddClick}
            disabled={isLoading}
            data-testid="add-fixed-binding-button"
            variant="secondary"
          >
            <Flexbox container alignItems="center">
              <Icon.Plus size="sm" />
              <Typography variant="body2">
                {intl.formatMessage({ id: I18nKeys.Add, defaultMessage: 'Add' })}
              </Typography>
            </Flexbox>
          </StyledButton>
        </AccessControl>
      </Flexbox>
      <Flexbox container gutter={1} style={{ flexWrap: 'wrap' }}>
        {fixedBindings.length > 0 ? (
          fixedBindings.map((binding) => (
            <Chip
              key={binding}
              text={binding}
              onDelete={() => onRemoveClick(binding)}
              isDeleting={isLoading}
              permission="iam.custom-role.update"
            />
          ))
        ) : (
          <Typography variant="body2" color={() => '#757575'} textAlign="center">
            {intl.formatMessage({ id: I18nKeys.CustomRolesFixedBindingsEmpty })}
          </Typography>
        )}
      </Flexbox>
    </FixedBindingsContainer>
  );
};
